var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("我的主控台")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("系統總覽")])], 1)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 grid-margin"
  }, [_c('div', {
    staticClass: "card card-statistics"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card-col col-xl-12 col-lg-12 col-md-12 col-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "\n                  d-flex\n                  align-items-center\n                  justify-content-center\n                  flex-column flex-sm-row\n                "
  }, [_c('img', {
    staticClass: "line-icon mr-1",
    style: _vm.lineIconStyle
  }), _c('div', {
    staticClass: "wrapper text-center text-sm-left"
  }, [_c('p', {
    staticClass: "card-text mb-0"
  }, [_vm._v(" Line 資訊 "), _c('i', {
    staticClass: "fa fa-question-circle s-text-primary",
    attrs: {
      "role": "button",
      "aria-hidden": "true",
      "id": "info-tooltip-line-bot"
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "info-tooltip-line-bot",
      "triggers": "hover",
      "placement": "right"
    }
  }, [_c('div', [_c('p', [_vm._v("Basic ID: " + _vm._s(_vm.botInfo.basicId))]), _vm.botInfo.premiumId ? _c('p', [_vm._v(" Premium ID: " + _vm._s(_vm.botInfo.premiumId))]) : _vm._e(), _vm.botInfo.pictureUrl ? _c('img', {
    staticClass: "info-img",
    attrs: {
      "src": _vm.botInfo.pictureUrl
    }
  }) : _vm._e()])])], 1), _c('div', {
    staticClass: "fluid-container"
  }, [_c('h3', {
    staticClass: "mb-0 font-weight-medium"
  }, [_vm._v(_vm._s(_vm.botName))])])])])])]), _vm._l(_vm.infos, function (info, idx) {
    return _c('div', {
      key: info.id,
      staticClass: "card-col col-xl-4 col-lg-4 col-md-4 col-6"
    }, [_c('div', {
      staticClass: "card-body"
    }, [_c('div', {
      staticClass: "\n                  d-flex\n                  align-items-center\n                  justify-content-center\n                  flex-column flex-sm-row\n                "
    }, [_c('i', {
      staticClass: "fa fa-3x mr-0 mr-sm-4 s-text-primary",
      class: info.icon
    }), _c('div', {
      staticClass: "wrapper text-center text-sm-left"
    }, [_c('p', {
      staticClass: "card-text mb-0"
    }, [_vm._v(" " + _vm._s(info.title) + " "), info.info ? _c('i', {
      staticClass: "fa fa-question-circle s-text-primary",
      attrs: {
        "role": "button",
        "aria-hidden": "true",
        "id": "info-tooltip-".concat(idx)
      }
    }) : _vm._e(), info.info ? _c('b-tooltip', {
      attrs: {
        "target": "info-tooltip-".concat(idx),
        "triggers": "hover",
        "placement": "right"
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(info.info)
      }
    })]) : _vm._e()], 1), _c('div', {
      staticClass: "fluid-container"
    }, [_c('h3', {
      staticClass: "mb-0 font-weight-medium"
    }, [_vm._v(_vm._s(info.value))])])])])])]);
  })], 2)])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }